export enum Weekday {
  sunday = 'sunday',
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  saturday = 'saturday',
}

export type Break = {
  startTime: string;
  endTime: string;
};

export type DisplaySchedule = {
  locationId?: string;
  startTime: string;
  endTime: string;
  breaks?: Break[];
};

export type Schedule = Record<Weekday, DisplaySchedule[]>;
export interface ScheduleType {
  locationId: string;
  dayOfWeek: Weekday;
  startTime: string;
  endTime: string;
  breaks: [
    {
      startTime: string;
      endTime: string;
    }
  ];
}

export type ScheduleAvailabilityByDayOfWeek = Partial<Record<Weekday, DisplaySchedule[]>>;
